'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifierModal = undefined;

var _ModifierModal2 = require('./ModifierModal');

var _ModifierModal3 = _interopRequireDefault(_ModifierModal2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ModifierModal = _ModifierModal3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/ModifierModal/index.js
// module id = 1619
// module chunks = 0